<template>
  <v-card class="ma-2">
    <v-card-title class="primary--text"
      >Upload
      <v-divider vertical class="ml-5 mx-0"></v-divider>
    </v-card-title>
    <v-divider class="mt-n4 mx-0"> </v-divider>
    <v-row class="ma-3">
      <v-col md="6">
        <v-select
          v-model="doctype"
          :items="doctypes"
          label="Upload Reason *"
          outlined
          dense
        ></v-select>
      </v-col>
      <v-col v-if="doctype.length != 0" md="6">
        <v-row>
          <v-spacer />
          <v-col md="">
            <UploadExcel
              :on-success="handleSuccess"
              :before-upload="beforeUpload"
            />
          </v-col>
          <v-col md="">
            <v-btn color="primary"
              ><v-icon>mdi-download</v-icon>Download Template</v-btn
            >
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-card>
      <v-card-title>Recent Uploads</v-card-title>
      <v-data-table :headers="headers" dense :items="desserts"></v-data-table>
    </v-card>
    <EditUploadDetails :EditUploadDialog="EditUploadDialog" ref="editupload" />
  </v-card>
</template>

<script>
import EditUploadDetails from "@/Views/Funds/EditUploadDetails.vue";
import UploadExcel from "@/components/UploadExcel/index.vue";
// import XLSX from "xlsx";

export default {
  components: {
    EditUploadDetails,
    UploadExcel,
  },
  data: () => ({
    headers: [
      {
        text: "Name",
        value: "Name",
      },
      {
        text: "Phone Number",
        value: "Phno",
      },
      {
        text: "Proxy Number",
        value: "proxynumber",
      },
      {
        text: "Payment reason",
        value: "Reason",
      },
      {
        text: "Amount",
        value: "Amount",
      },
      {
        text: "Currency",
        value: "Currency",
      },
    ],
    desserts: [
      {
        Name: "Anusha",
        proxynumber: "8486454454",
        Phno: "8955552223",
        Reason: "Salary",
        Amount: "100",
        Currency: "RM",
      },
      {
        Name: "Athish",
        proxynumber: "8989898989",
        Phno: "2322555555",
        Reason: "Salary",
        Amount: "200",
        Currency: "RM",
      },
    ],
    EditUploadDialog: false,
    exceldata: { tabledata: null, tableheader: null },

    doctype: "",
    doctypes: ["abc", "salary"],
  }),
  methods: {
    beforeUpload(file) {
      const isLt1M = file.size / 1024 / 1024 < 1;
      if (isLt1M) {
        return true;
      }
      this.$message({
        message: "Please do not upload files larger than 1m in size.",
        type: "warning",
      });
      return false;
    },
    handleSuccess({ results, header }) {
      this.exceldata.tabledata = results;
      this.exceldata.tableheader = header;
      this.EditUploadDialog = true;
      this.$refs.editupload.getexceldata(this.exceldata);
      // this.MakeHeadersMethod();
    },
  },
};
</script>

<style>
</style>